module.exports = "<div ng-repeat=\"entry in $ctrl.data\">\n    <dl>\n        <dt>{{entry.for.firstName}} {{entry.for.lastName}} - {{entry.for.companyName}}</dt>\n        <dd>{{entry.testimonial}}</dd>\n    </dl>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/sidebar/testimonials-widget/testimonials-widget.component.html
// module id = 678
// module chunks = 0